<h1>Welcome to the Aurelia Virtual Repeat!</h1>

<b>Go to one of the following examples:</b>
<ul>
  <li>
    <a load="/basic-app">Basic usage</a>
  </li>
  <li>
    <a load="/container-animation-transition">With scroller transition animation</a>
  </li>
  <li>
    <a load="/table-app">Basic table usage</a>
  </li>
</ul>
